// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9dc1a0c7","703":"0cee26c1","839":"530945ed"}[chunkId] + ".chunk.js";
};